import { useEffect, useState } from 'react';

/**
 * `useExperiment` is a custom React hook that fetches experiment data from the /locations API.
 * The experiment data includes the variant of the experiment.
 *
 * @function
 * @module useExperiment
 * @param {Array} locations - An array of location to search for
 * @returns {Object} response - An object with the location and its contents
 * @example
 * const experimentData = useExperiment(locations);
 */
const useExperiment = locations => {
  const [experimentData, setExperimentData] = useState();

  useEffect(() => {
    const fetchExperimentData = async () => {
      try {
        const response = await window?.webShellClient?.optimization.getLocations?.(
          { locations },
          false,
          null,
          true,
        );
        if (response?.locations.length > 0) {
          setExperimentData(response);
        } else {
          setExperimentData(null);
        }
      } catch (e) {
        setExperimentData(null);
      }
    };

    fetchExperimentData();
  }, []);

  return experimentData;
};

/**
 * Get a specific experiment.
 * @param experimentData
 * @param name
 * @returns {unknown|null}
 */
export function getExperiment(experimentData, name) {
  if (!experimentData || !experimentData?.locations?.length) {
    return null;
  }
  return experimentData.locations.find(item => item.name === name);
}

export default useExperiment;
